import GameObject from '../../../GameObject/GameObject';
import AnimationClip from '../AnimationClip';
import BaseCard from '../../../Prototype/Level/Card/BaseCard';
import TransformComponent from '../../../Component/Transform';
import { Easing } from '@tweenjs/tween.js';
import Renderable from '../../../Component/Renderable';
import { delay } from '../../../Utility/Task/TaskQueue';
import { CARD_STACK_OFFSET } from '../../../Constants/InGame';
import { getStackCardTargetX } from '../../../State/Card/CardStateHelper';
import CardComponent from 'Component/Level/Card';
import CardSystem from '../../Card/CardSystem';
import { Anim } from '../AnimationHelper';

interface IReturnToStackMeta {
    cards: BaseCard[];
    stackContainer: GameObject;
    duration: number;
    delayStart: number;
    delayInterval: number;
    stackCount: number;
    system: CardSystem;
}
export class ReturnToStack extends AnimationClip {
    public *execute(
        animator: GameObject,
        meta: IReturnToStackMeta
    ): IterableIterator<number> {
        let stackCount: number = meta.stackCount || 0;

        const reversedCards: BaseCard[] = [...meta.cards].reverse();
        for (let i = 0; i < reversedCards.length; i++) {
            const card = reversedCards[i];
            const cardTransform = card.getComponent(TransformComponent);
            const cardComponent = card.getComponent(CardComponent);
            const tweenPosition = this.getTween(cardTransform.position);
            const tweenRotation = this.getTween(cardTransform);
            card.getComponent(Renderable).visible = true;

            // Add as child to animator first for relative positioning.
            animator.addChild(card);

            // Add as child to stack container.
            meta.stackContainer.addChild(card);

            tweenPosition
                .to(
                    {
                        x: CARD_STACK_OFFSET,
                        y: 0,
                    },
                    meta.duration
                )
                .delay(meta.delayStart + i * meta.delayInterval)
                .easing(Easing.Cubic.InOut)
                .onComplete(() => {
                    stackCount += 1;
                    const cards = [...meta.system.getCardsInStack(), ...reversedCards].slice(0, stackCount);

                    for (let j = 0; j < cards.length; j++) {
                        Anim(cards[j], {
                            duration: 300,
                            x: getStackCardTargetX(j, cards.length),
                            easing: Easing.Sinusoidal.Out,
                        });
                    }
                })
                .start(this.elapsedTime);

            tweenRotation
                .to(
                    {
                        rotation: 0,
                    },
                    meta.duration
                )
                .delay(meta.delayStart + i * meta.delayInterval)
                .easing(Easing.Quadratic.InOut)
                .start(this.elapsedTime);
        }

        yield* delay(
            meta.duration +
                meta.delayStart +
                meta.cards.length * meta.delayInterval
        );
    }
}
